import React from 'react';
import 'react-day-picker';
import 'react-day-picker/lib/style.css';
import Form from "react-jsonschema-form";
import RadioWidget from "react-jsonschema-form/lib/components/widgets/RadioWidget"
import ReactDatePicker from "react-jsonschema-form-extras/lib/ReactDatePicker";
import { TypeaheadField, AsyncTypeaheadField } from "react-jsonschema-form-extras/lib/TypeaheadField";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { actionCreators } from '../store/Form';
import ObjectFieldTemplate from './JsonSchemaFormObjectFieldTemplate';
import { withRouter } from 'react-router-dom';
import FormStepper from './FormStepper';
import applyRulesHoc from './applyRulesHoc';
import Engine from 'json-rules-engine-simplified';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions } from '@material-ui/core';
import LoadingOverlay from 'react-loading-overlay';
import './FormBuilder.css'
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input'
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { authHeader } from '../services/authHeaderService';
import { isEmpty } from 'lodash';
import NumberFormat from 'react-number-format';

const successorTypes = [
    "Successor Holder",
    "Successor Annuitant"
];

const regularBeneficiaryTypes = [
    "Beneficiary",
    "Charity",
    "Estate"
];

const contingentBeneficiaryTypes = [
    "Contingent Beneficiary"
];

const transformErrors = (errors = []) => {
    //log errors for now to show silent errors
    errors.map(error => {
        if (error.message === "should match pattern \"^[0-9]{9}$\"") {
            error.message = "Tax identification number should be a 9-digit all number value!";
        }
        
        if (error.name === "required") {
            error.message = "required";
        }
        
        if (error.name === "oneOf") {
            error.message = null;
        }
        
        if (error.property.indexOf("RecordType") > -1 && error.message.indexOf("should be equal to one of the allowed values") > -1) {
            error.message = "Please complete this section properly before submission.";
        }
        
        if (error.property.indexOf("Allocation_Percentage__c") > -1 && error.message.indexOf("required") > -1) {
            error.message = "Please complete this section properly before submission.";
        }

        return error;
    });
    
    //Remove duplicate errors (name property and message are all same) 
    //because of oneOf schema dependencies doesn't work as expected right now,
    //This piece of code might be removed later when it is resolved
    var newErrors = errors.reduce((newErrorArray, currError) => {
        if(!newErrorArray.find(existingError => 
            existingError.property === currError.property 
            && existingError.name === currError.name 
            && existingError.message === currError.message)) {
            newErrorArray.push(currError);
        }
        
        return newErrorArray;
    }, []);

    return newErrors;
}


class BeneficiaryTypeaheadAutocomplete extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          ...props.formData,
            isLoading: false,
            options: [],
            modalOpen: false,
            isSubmittingContact: false,
            newContactFirstName: "",
            newContactLastName: "",
            newContactId: "",
            newContactBirthdate: "",
            newContactTax_ID__c: "",
            errors: {},
            forceSelected: [{
                FirstName: props.formData ? props.formData.FirstName : undefined,
                LastName: props.formData ? props.formData.LastName : undefined,
                Id: props.formData ? props.formData.Id : undefined ,
                Birthdate: props.formData ? props.formData.Birthdate : undefined,
                Tax_ID__c: props.formData ? props.formData.Tax_ID__c : undefined,
            }]
            };
      this.onChangeBirthdate = this.onChangeBirthdate.bind(this);
      this.onChangeFirstName = this.onChangeFirstName.bind(this);
      this.onChangeSinNumber = this.onChangeSinNumber.bind(this);
      this.onChangeFirstNameOnly = this.onChangeFirstNameOnly.bind(this);
      this.onChangeLastName = this.onChangeLastName.bind(this);
      this.handleClickOpen = this.handleClickOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleSubmitContact = this.handleSubmitContact.bind(this);
      this.validateNewContact = this.validateNewContact.bind(this);
      this.onChangeNewContact = this.onChangeNewContact.bind(this);
      this.onChangeNewContactBirthdate = this.onChangeNewContactBirthdate.bind(this);
      this.typeaheadInstance = React.createRef();
      this.props.onChange(this.state);
    }
    
    handleClickOpen() {
        this.setState({
            modalOpen: true
        }, () => this.props.onChange(this.state));
    }
    
    handleClose () {
        this.setState({
            modalOpen: false,
            newContactFirstName: "",
            newContactLastName: "",
            newContactId: "",
            newContactBirthdate: "",
            newContactTax_ID__c: "",
            isSubmittingContact: false,
            errors: {}
        }, () => this.props.onChange(this.state));
    }
    
    handleSubmitContact() {
        const errors = this.validateNewContact(this.state);
        this.setState({ errors });
        if (Object.entries(errors).length === 0 && errors.constructor === Object) {
            this.setState({
                isSubmittingContact: true
            }, () => this.props.onChange(this.state));
            
            let newContactCompositeRequest = {
                "allOrNone": true,
                "compositeRequest": []
            };
            newContactCompositeRequest.compositeRequest.push({
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/Contact/",
                "referenceId": "NewContact",
                "body": {
                    "FirstName": this.state.newContactFirstName,
                    "LastName": this.state.newContactLastName,
                    "Birthdate": this.state.newContactBirthdate,
                    "Tax_ID__c": this.state.newContactTax_ID__c,
                    "RecordTypeId": "012f4000000UeXEAA0"
                }
            });
            const tpiurl = `api/t/''`;
            fetch(tpiurl, {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(JSON.stringify(newContactCompositeRequest))
            })
                .then(resp => resp.json())
                .then(respJson => 
                    {
                        let respStatusCode = respJson.compositeResponse[0].httpStatusCode;
                        let respBody = respJson.compositeResponse[0].body;
                        if (respStatusCode >= 400) {
                            this.setState({
                                newContactFirstName: "",
                                newContactLastName: "",
                                newContactId: "",
                                newContactBirthdate: "",
                                newContactTax_ID__c: "",
                                isSubmittingContact: false
                            }, () => this.props.onChange(this.state));
                        } else {
                            if (respBody.id && respBody.success) {
                                this.setState({
                                    modalOpen: false,
                                    FirstName: this.state.newContactFirstName,
                                    LastName: this.state.newContactLastName,
                                    Id: respBody.id,
                                    Birthdate: this.state.newContactBirthdate,
                                    Tax_ID__c: this.state.newContactTax_ID__c,
                                    newContactFirstName: "",
                                    newContactLastName: "",
                                    newContactId: "",
                                    newContactBirthdate: "",
                                    newContactTax_ID__c: "",
                                    isSubmittingContact: false
                                }, () => this.props.onChange(this.state));
                                this.setState({
                                    forceSelected: [{
                                        FirstName: this.state.FirstName,
                                        LastName: this.state.LastName,
                                        Id: this.state.Id,
                                        Birthdate: this.state.Birthdate,
                                        Tax_ID__c: this.state.Tax_ID__c
                                    }]
                                  }, () => this.props.onChange(this.state));
                            }
                        }
                    });            
        }
    }
    
    validateNewContact(data) {
        const errors = {};
        if (!data.newContactFirstName || data.newContactFirstName.trim().length === 0) errors.newContactFirstName = "Can't be blank";
        if (!data.newContactLastName || data.newContactLastName.trim().length === 0) errors.newContactLastName = "Can't be blank";
        if (!data.newContactBirthdate || data.newContactBirthdate.trim().length === 0) errors.newContactBirthdate = "Can't be blank";
        if  (this.props.schema.properties.Tax_ID__c) {
            if (!data.newContactTax_ID__c || data.newContactTax_ID__c.trim().length === 0) errors.newContactTax_ID__c = "Can't be blank";
        }
        return errors;
    }
    
    onChangeNewContact(name) {
        return (event) => {
            this.setState({
              [name]: event.target.value
            }, () => this.props.onChange(this.state));
        };
    }
    
    onChangeNewContactBirthdate(value) {
        this.setState({
            newContactBirthdate: value
          }, () => this.props.onChange(this.state));
      }
    
    onChangeBirthdate(value) {
        this.setState({
            Birthdate: value
          }, () => this.props.onChange(this.state));
      }
      
      onChangeSinNumber(event) {
        this.setState({
            Tax_ID__c: event.target.value
          }, () => this.props.onChange(this.state));
      }
      
      onChangeFirstName(value) {
         if(value && value.length > 0) {
            if (!this.props.schema.properties.Tax_ID__c) {
                this.setState({
                    forceSelected: [
                        {
                            FirstName: value[0].FirstName,
                            LastName: value[0].LastName,
                            Id: value[0].Id,
                            Birthdate: value[0].Birthdate !== null ? value[0].Birthdate : ""          
                        }
                    ],
                    FirstName: value[0].FirstName,
                    LastName: value[0].LastName,
                    Id: value[0].Id,
                    Birthdate: value[0].Birthdate !== null ? value[0].Birthdate : ""                
                }, () => this.props.onChange(this.state));
            } else {
                this.setState({
                    forceSelected: [
                        {
                            FirstName: value[0].FirstName,
                            LastName: value[0].LastName,
                            Id: value[0].Id,
                            Tax_ID__c: value[0].Tax_ID__c,
                            Birthdate: value[0].Birthdate !== null ? value[0].Birthdate : ""
                        }
                    ],
                    FirstName: value[0].FirstName,
                    LastName: value[0].LastName,
                    Id: value[0].Id,
                    Tax_ID__c: value[0].Tax_ID__c,
                    Birthdate: value[0].Birthdate !== null ? value[0].Birthdate : ""
                }, () => this.props.onChange(this.state));
            }
         }
      }
      
      onChangeFirstNameOnly(value) {
        this.setState({
            FirstName: value,
            Id: undefined,
            forceSelected: []
        }, () => this.props.onChange(this.state));
      }
      
      onChangeLastName(event) {
        this.setState({
            LastName: event.target.value,
            Id: undefined,
            forceSelected: []
        }, () => this.props.onChange(this.state));
      }
    
    _handleSearch = (query) => {
        this.setState({isLoading: true});
        fetch(`/api/contacts?q=${query}`,{
            method: 'GET',
            headers: authHeader()                    
        })
            .then(resp => resp.json())
            .then(json => this.setState({
                isLoading: false,
                options: json,
            }));
      }
    
    render() {
      const { FirstName, LastName, Birthdate, Tax_ID__c, 
        options, modalOpen, isSubmittingContact, newContactFirstName, newContactLastName, newContactBirthdate, newContactTax_ID__c, errors, forceSelected } = this.state;
      let birthDateError;
      let firstNameError;
      let lastNameError;
      let idError;
      let sinError;

      if (this.props.errorSchema) {
        if (this.props.errorSchema.Id && this.props.errorSchema.Id.__errors) {
            if (this.props.errorSchema.Id.__errors.includes("required")) {
                idError = <ul className="error-detail bs-callout bs-callout-info"><li className="text-danger">Please pick a contact from our record, or add a new one here</li></ul>;
            }
        }
        
        if (this.props.errorSchema.Birthdate && this.props.errorSchema.Birthdate.__errors) {
            if (this.props.errorSchema.Birthdate.__errors.includes("required")) {
                birthDateError = <ul className="error-detail bs-callout bs-callout-info"><li className="text-danger">Birthdate is required</li></ul>;
            }
        }
        
        if (this.props.errorSchema.LastName && this.props.errorSchema.LastName.__errors) {
            if (this.props.errorSchema.LastName.__errors.includes("required")) {
                lastNameError = <ul className="error-detail bs-callout bs-callout-info"><li className="text-danger">LastName is required</li></ul>;
            }
        }
        
        if (this.props.errorSchema.FirstName && this.props.errorSchema.FirstName.__errors) {
            if (this.props.errorSchema.FirstName.__errors.includes("required")) {
                firstNameError = <ul className="error-detail bs-callout bs-callout-info"><li className="text-danger">FirstName is required</li></ul>;
            }
        }
        
        if (this.props.errorSchema.Tax_ID__c && this.props.errorSchema.Tax_ID__c.__errors) {
            if (this.props.errorSchema.Tax_ID__c.__errors.includes("required")) {
                sinError = <ul className="error-detail bs-callout bs-callout-info"><li className="text-danger">SIN number is required</li></ul>;
            }
        }
      }
      
      let autoFocus = false;
      if (FirstName == "" || !FirstName) {
        autoFocus = true;
      }
      
      let sinInputField;
      let newContactSinField;
      if (this.props.schema.properties.Tax_ID__c) {
        sinInputField = 
            <div className="object-field-wrapper col-md-4">
                <div className="form-group field">
                    <label htmlFor={this.props.idSchema.Tax_ID__c}>
                        SIN Number
                        <span className="required">*</span>
                    </label>
                <input className="form-control" id={this.props.idSchema.Tax_ID__c.$id} onChange = {this.onChangeSinNumber} label="SIN Number" required="" placeholder="" value={Tax_ID__c||""} />
                </div>
                {sinError}
            </div>;
        newContactSinField = 
            <TextField
                error={errors.newContactTax_ID__c !== undefined && errors.newContactTax_ID__c !== null}
                margin="dense"
                id="sinNumber"
                label="SIN Number"
                type="string"
                fullWidth
                required
                value={newContactTax_ID__c}
                onChange={this.onChangeNewContact("newContactTax_ID__c")}
                helperText={errors.newContactTax_ID__c}
        />
      }
          
      return (
        <div className="row">
            <div className="col-md-4"> First name: <span className="required">*</span> 
                <AsyncTypeahead
                    onSearch={this._handleSearch}
                    minLength={0}
                    labelKey={(option) => {
                        if (option.FirstName) {
                            return option.FirstName;
                        } else {
                            return "";
                        }
                    }}
                    filterBy={['AccountName']}
                    // defaultInputValue={FirstName}
                    onChange = {this.onChangeFirstName}
                    onInputChange = {(value) => this.onChangeFirstNameOnly(value)}
                    options={options}
                    id={this.props.idSchema.FirstName.$id}
                    autoFocus={autoFocus}
                    defaultOpen={autoFocus}
                    placeholder="Search name..."
                    selected={forceSelected}
                    required={this.props.schema.required.includes("FirstName")}
                    renderMenuItemChildren={(option) => (
                        <div style={{marginBottom: '10px'}}>
                            <span>First name: {option.FirstName ? option.FirstName : ""}</span><br/>
                            <span>Last name: {option.LastName ? option.LastName : ""}</span>
                        </div>
                      )}
                    ref={this.typeaheadInstance}
                    {...this.state}>{this.props.errors}</AsyncTypeahead> 
                    {firstNameError}
            </div>
            <div className="col-md-4"> Last name: <span className="required">*</span> 
                <input className="form-control" 
                    id={this.props.idSchema.LastName.$id} 
                    onChange = {this.onChangeLastName} 
                    label="LastName" 
                    required={this.props.schema.required.includes("LastName")} 
                    placeholder="Last Name here" 
                    value={LastName||""} />
                {lastNameError}
            </div>
            <div>
                <br />
                <Button variant="contained" color="primary" onClick={this.handleClickOpen} style={{bottom: '4px'}}>
                    Add new contact
                </Button>
                <Dialog open={modalOpen} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <LoadingOverlay active={isSubmittingContact} spinner text='Submitting your contact...'>
                    <DialogTitle id="form-dialog-title">New contact</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Add the contact you cannot find in our system:
                            </DialogContentText>
                            <TextField
                                autoFocus
                                error={errors.newContactFirstName !== undefined && errors.newContactFirstName !== null}
                                margin="dense"
                                id="firstName"
                                label="First name"
                                type="string"
                                fullWidth
                                required
                                value={newContactFirstName}
                                onChange={this.onChangeNewContact("newContactFirstName")}
                                helperText={errors.newContactLastName}
                            />
                            <TextField
                                error={errors.newContactLastName !== undefined && errors.newContactLastName !== null}
                                margin="dense"
                                id="lastName"
                                label="Last name"
                                type="string"
                                fullWidth
                                required
                                value={newContactLastName}
                                onChange={this.onChangeNewContact("newContactLastName")}
                                helperText={errors.newContactLastName}
                            />
                            <MaterialUIDatePicker
                                id="birthDate"
                                type="string"
                                required
                                value={newContactBirthdate}
                                onChange={this.onChangeNewContactBirthdate}
                                helperText={errors.newContactBirthdate}
                                error={errors.newContactBirthdate ? true : false}
                                labelString="Date of Birth"
                                />
                            {newContactSinField}
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button onClick={this.handleSubmitContact} type="submit" color="primary">
                            Add
                        </Button>
                        </DialogActions>
                    </LoadingOverlay>
                </Dialog>
            </div>
            <div className="col-md-4"> Birthdate: 
            <MaterialUIDatePicker
                id={this.props.idSchema.Birthdate.$id}
                type="string"
                value={Birthdate}
                onChange={this.onChangeBirthdate}
                required={this.props.schema.required.includes("Birthdate")} />
            {birthDateError}
            </div>
            {sinInputField}
            {idError}
        </div>
      );
    }
}

const CurrencyNumberFormat = (props) => {
    return (
        <NumberFormat
            className="form-control"
            value={props.value}
            required={props.required}
            id={props.id}
            error={props.error}
            label={props.labelString}
            thousandSeparator={true}
            onValueChange ={value => {
                props.onChange(value.value);
            }}
            disabled={props.disabled}
            prefix={'$'} />
    )
};

const MaterialUIDatePicker = (props) => {
    const { options } = props;
    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
                placeholder="YYYY/MM/DD"
                //Since default date is being take in as UTC and our timezone is 6 hour before so it is converted to one day before
                //Using Moment js here
                value={!isEmpty(props.value) ? moment(props.value) : null}
                required={props.required}
                disabled={props.disabled || ((options === undefined || options === null) ? false : options.disabled)}
                onChange={value => props.onChange(!isEmpty(value) ? moment(value).format('YYYY-MM-DD') :  undefined)}
                format="YYYY/MM/DD" 
                maxDate={new Date()}
                id={props.id}
                helperText={props.helperText}
                error={props.error}
                helperText={"Format YYYY/MM/DD"}
                label={props.labelString} />
        </MuiPickersUtilsProvider>
    );
};

class PhoneNumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            id: props.id,
            label: props.label,
            error: props.error
        };
    }
    
    render() {
        return (
            <PhoneInput
                placeholder="Enter phone number"
                value={this.state.value||''}
                id={this.state.id}
                limitMaxLength={true}
                displayInitialValueAsLocalNumber={true}
                label={this.state.label}
                error={this.state.error}
                country={"CA"}
                countries={["CA", "US", "GU", "AS", "MP", "PR", "VI"]}
                onChange={value => {
                    this.setState({value});
                    if (!isEmpty(value)) {
                        let phoneNumber = parsePhoneNumber(value);
                        if (phoneNumber) {
                            if (phoneNumber.countryCallingCode === '1') {
                                if (isValidPhoneNumber(value)) {
                                    let nationalNumber = phoneNumber.nationalNumber;
                                    let reformattedNationalNumber = nationalNumber.substring(0,3) + "-" + nationalNumber.substring(3,6) + "-" + nationalNumber.substring(6);
                                    this.props.onChange("+1 " + reformattedNationalNumber);
                                } else {
                                    this.props.onChange(value);
                                }
                            } else {
                                if (isValidPhoneNumber(value)) {
                                    this.props.onChange("+" + phoneNumber.countryCallingCode + " " + phoneNumber.nationalNumber);
                                } else {
                                    this.props.onChange(value);
                                }
                            }
                        } else {
                            this.props.onChange(value);
                        }
                    } else {
                        this.props.onChange("");
                    }
                }}
            />
        );
    }
}

const AddressInput = (props) => {
    const newLineChar = '\n';

    const enforceRowCharLimit = (rows, lastChar) => {
        const maxChars = 40;

        let preventChange = false;

        for (let i = 0; i < rows.length && !preventChange; i ++) {
            if (rows[i].length > maxChars && lastChar !== newLineChar) {
                preventChange = true;
            }
    
        }

        return preventChange;
    }

    const onAddressChange = (newValue) => {
        const maxRows = 4;
        const rows = newValue ? newValue.split(newLineChar) : [''];
        const lastChar = newValue[newValue.length-1];
        const value = (props.value !== undefined && props.value !== null) ? props.value : '';
        const isBackspacing = (newValue.length < value.length);

        if (!isBackspacing &&
            (rows.length > maxRows || enforceRowCharLimit(rows, lastChar))) {
            newValue = value;
        }

        if (newValue.trim().length === 0) {
            newValue = undefined;
        }

        props.onChange(newValue);
    }

    return (
        <textarea 
            className="form-control"
            value={props.value}
            onChange={(event) => onAddressChange(event.target.value)} 
            rows={3}
            maxLength={163}
        />
    );
  };

const SinInput = (props) => {
    const onSinChange = (newValue) => {
        const value = (props.value !== undefined && props.value !== null) ? props.value : '';

        if (newValue && newValue.length > 0 && !newValue.match(/^[0-9]+$/)) {
            newValue = value;
        } else if (newValue.trim().length === 0) {
            newValue = undefined;
        }

        props.onChange(newValue);
    }

    return (
        <input 
            type="text"
            className="form-control"
            value={props.value}
            onChange={(event) => onSinChange(event.target.value)} 
        />
    );
};

const widgets = {
    materialDatePicker: MaterialUIDatePicker,
    radio: RadioWidget,
    phoneNumberInput: PhoneNumberInput,
    currencyNumberFormat: CurrencyNumberFormat,
    addressInput: AddressInput,
    sinInput: SinInput
};

const isValidAddress = (address) => {
    return /^[\x20-\x7E|ÀÁÂÇÈÉÊËÌÍÎÏÒÓÔÙÚÛÜÝ|\n|\r]*$/.test(address);
}

const isValidPostalCode = (postalCode) => {
    return /^[\x30-\x39|\x41-\x5A|\x61-\x7A|\n|\r|\s]*$/.test(postalCode);
}

const validateAddress = (formData, errors) => {
    if(formData["Account-BillingStreet"] && !isEmpty(formData["Account-BillingStreet"])) {
        if(!isValidAddress(formData["Account-BillingStreet"])) {
            errors["Account-BillingStreet"].addError("Invalid character detected for Primary Address");
        }
    }

    if(formData["Account-BillingCity"] && !isEmpty(formData["Account-BillingCity"])) {
        if(!isValidAddress(formData["Account-BillingCity"])) {
            errors["Account-BillingCity"].addError("Invalid character detected for City");
        }
    }

    if(formData["Account-BillingPostalCode"] && !isEmpty(formData["Account-BillingPostalCode"])) {
        if(!isValidPostalCode(formData["Account-BillingPostalCode"])) {
            errors["Account-BillingPostalCode"].addError("Invalid character detected for Postal Code");
        }
    }

    if(formData["Account-ShippingStreet"] && !isEmpty(formData["Account-ShippingStreet"])) {
        if(!isValidAddress(formData["Account-ShippingStreet"])) {
            errors["Account-ShippingStreet"].addError("Invalid character detected for Mailing Street Address");
        }
    }

    if(formData["Account-ShippingCity"] && !isEmpty(formData["Account-ShippingCity"])) {
        if(!isValidAddress(formData["Account-ShippingCity"])) {
            errors["Account-ShippingCity"].addError("Invalid character detected for City");
        }
    }

    if(formData["Account-ShippingPostalCode"] && !isEmpty(formData["Account-ShippingPostalCode"])) {
        if(!isValidPostalCode(formData["Account-ShippingPostalCode"])) {
            errors["Account-ShippingPostalCode"].addError("Invalid character detected for Postal Code");
        }
    }
}

const validatePoaAddress = (formData, errors) => {
    if(formData["PoaAccount-BillingStreet"] && !isEmpty(formData["PoaAccount-BillingStreet"])) {
        if(!isValidAddress(formData["PoaAccount-BillingStreet"])) {
            errors["PoaAccount-BillingStreet"].addError("Invalid character detected for Address");
        }
    }

    if(formData["PoaAccount-BillingCity"] && !isEmpty(formData["PoaAccount-BillingCity"])) {
        if(!isValidAddress(formData["PoaAccount-BillingCity"])) {
            errors["PoaAccount-BillingCity"].addError("Invalid character detected for City");
        }
    }

    if(formData["PoaAccount-BillingPostalCode"] && !isEmpty(formData["PoaAccount-BillingPostalCode"])) {
        if(!isValidAddress(formData["PoaAccount-BillingPostalCode"])) {
            errors["PoaAccount-BillingPostalCode"].addError("Invalid character detected for Postal Code");
        }
    }
}

const validate = (formData, errors) => {
    validateAddress(formData, errors);

    if (formData["Contact-HomePhone"] && !isEmpty(formData["Contact-HomePhone"])) {
        if (!isValidPhoneNumber(formData["Contact-HomePhone"])) {
            errors["Contact-HomePhone"].addError("Please check phone number format.");
        }
    }
    
    if (formData["Contact-Phone"] && !isEmpty(formData["Contact-Phone"])) {
        if (!isValidPhoneNumber(formData["Contact-Phone"])) {
            errors["Contact-Phone"].addError("Please check phone number format.");
        }
    }
    
    if (formData["Contact-MobilePhone"] && !isEmpty(formData["Contact-MobilePhone"])) {
        if (!isValidPhoneNumber(formData["Contact-MobilePhone"])) {
            errors["Contact-MobilePhone"].addError("Please check phone number format.");
        }
    }

    if (formData["PoaContact-Phone"] && !isEmpty(formData["PoaContact-Phone"])) {
        if (!isValidPhoneNumber(formData["PoaContact-Phone"])) {
            errors["PoaContact-Phone"].addError("Please check phone number format.");
        }
    }

    validatePoaAddress(formData, errors);

    const sin = formData["Contact-Tax_ID__c"];
    if (sin && !isEmpty(sin) && !sin.match(/^[0-9]{9}$/)) {
        errors["Contact-Tax_ID__c"].addError("SIN must be 9 digits long with no dashes or spaces.");
    }
    
    if (formData.financialAssetsBreakdownSum !== 100 
        && formData.financialAssetsBreakdownSum !== undefined 
        && formData.financialAssetsBreakdownSum !== null) {
        errors["AssetAllocationCash-Asset_Percentage__c"].addError();
        errors["AssetAllocationFixedIncome-Asset_Percentage__c"].addError();
        errors["AssetAllocationEquity-Asset_Percentage__c"].addError("Financial assets breakdown sum is not 100%, please adjust the breakdown.");
    }
    
    //Rules for Beneficiary:
    //1.Client must selection "No election" or have beneficiary
    //5.successor holder/successor Annuitant mutually exclusive to estate/beneficiary/charity (done on schema level)
    if((!formData.Beneficiary__c || formData.Beneficiary__c.length < 1 ) && formData["FinServ__FinancialAccount__c-No_Beneficiary_Election"] === false) {
        errors["FinServ__FinancialAccount__c-No_Beneficiary_Election"].addError("Please select \"No election\" here or add beneficiaries.");
    }
    
    if(formData["FinServ__FinancialAccount__c-No_Beneficiary_Election"] === false && formData.Beneficiary__c && formData.Beneficiary__c.length > 0) {
        //2.If beneficiary exist, then Estate+Charity+Beneficiary (regular beneficiary list) / Successor Holder/Successor Annuitant= 100%
        if (formData.TotalBeneficiaryPercentage !== 100) {
            let maxIndex = 0;
            let regularBeneficiaryIndexList = []
            for (let i = 0;i < formData.Beneficiary__c.length;i++) {
                if (regularBeneficiaryTypes.includes(formData.Beneficiary__c[i].RecordType) || successorTypes.includes(formData.Beneficiary__c[i].RecordType)) {
                    regularBeneficiaryIndexList.push(i);
                }
            }
            
            if (regularBeneficiaryIndexList.length > 0) {
                for(let beneficiaryErrorKey in regularBeneficiaryIndexList) {
                    maxIndex = regularBeneficiaryIndexList[beneficiaryErrorKey];
                    if(errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c) {
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError();
                    } else {
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c = {
                            __errors: [],
                            addError: function addError(message) {
                              this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError();
                    }
                }
                errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError("Beneficiary allocation percentage total must be 100%.");
            }           
        }
        
        //4.If contingent benficiary exist, then all of them must = 100%
        if (formData.TotalContingentBeneficiaryPercentage !== 100) {
            let maxIndex = 0;
            let contingentBeneficiaryIndexList = []
            for (let j = 0 ; j < formData.Beneficiary__c.length ; j++) {
                if (contingentBeneficiaryTypes.includes(formData.Beneficiary__c[j].RecordType)) {
                    contingentBeneficiaryIndexList.push(j);
                }
            }
                        
            if (contingentBeneficiaryIndexList.length > 0) {
                for(let contingentBeneficiaryErrorKey in contingentBeneficiaryIndexList) {
                    maxIndex = contingentBeneficiaryIndexList[contingentBeneficiaryErrorKey];

                    if(errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c) {
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError();
                    } else {
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c = {
                            __errors: [],
                            addError: function addError(message) {
                              this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError();
                    }
                }
                errors["Beneficiary__c"][maxIndex].Allocation_Percentage__c.addError("If you have added contingent beneficiaries, please make sure beneficiary allocation percentage total to be 100%.");
            }
        }
        //3.Successor Holder/Successor Annuitant is unique and cannot allow duplicate
        //5.successor holder/successor Annuitant mutually exclusive to estate/beneficiary/charity (done on schema level and here to enforce)
        let successorHolderArray = [];
        for(let k = 0;k<formData.Beneficiary__c.length;k++) {
            if (formData.Beneficiary__c[k].RecordType === "Successor Holder") {
                successorHolderArray.push(k);
            }
        }
        
        if(successorHolderArray.length >= 1) {
            let regularBeneficiaryArray = [];
            for(let l = 0;l<formData.Beneficiary__c.length;l++) {
                if (regularBeneficiaryTypes.includes(formData.Beneficiary__c[l].RecordType)) {
                    regularBeneficiaryArray.push(l);
                }
            }

            // for beneficiary type conflict: successor holder and normal beneficiaries
            if (regularBeneficiaryArray && regularBeneficiaryArray.length > 0) {
                for(let beneficiaryErrorKey in regularBeneficiaryArray) {                
                    let currIndex = regularBeneficiaryArray[beneficiaryErrorKey];
    
                    if(errors["Beneficiary__c"][currIndex].RecordType) {
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    } else {
                        errors["Beneficiary__c"][currIndex].RecordType = {
                            __errors: [],
                            addError: function addError(message) {
                              this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    }
                }
                            
            for(let successorHolderErrorKey in successorHolderArray) {                
                let currSuccessorHolderIndex = successorHolderArray[successorHolderErrorKey];

                if(errors["Beneficiary__c"][currSuccessorHolderIndex].RecordType) {
                    errors["Beneficiary__c"][currSuccessorHolderIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                } else {
                    errors["Beneficiary__c"][currSuccessorHolderIndex].RecordType = {
                        __errors: [],
                        addError: function addError(message) {
                          this.__errors.push(message);
                        }
                    };
                    errors["Beneficiary__c"][currSuccessorHolderIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                }
            }
            }
            
            //duplicate successor holder
            if (successorHolderArray.length > 1) {
                for(let dupSuccessorHolderErrorKey in successorHolderArray) {                
                    let currDupSuccessorHolderIndex = successorHolderArray[dupSuccessorHolderErrorKey];
    
                    if(errors["Beneficiary__c"][currDupSuccessorHolderIndex].RecordType) {
                        errors["Beneficiary__c"][currDupSuccessorHolderIndex].RecordType.addError("Please don't try to trick the form! You won't go forward! XD");
                    } else {
                        errors["Beneficiary__c"][currDupSuccessorHolderIndex].RecordType = {
                            __errors: [],
                            addError: function addError(message) {
                              this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][currDupSuccessorHolderIndex].RecordType.addError("Please don't try to trick the form! You won't go forward! XD");
                    }
                }
            }
        }
        
        let successorAnnuitantArray = [];
        for(let m = 0 ; m < formData.Beneficiary__c.length ; m ++) {
            if (formData.Beneficiary__c[m].RecordType === "Successor Annuitant") {
                successorAnnuitantArray.push(m);
            }
        }
        
        if(successorAnnuitantArray.length >= 1) {
            let regularBeneficiaryArray = [];
            for(let n = 0 ; n < formData.Beneficiary__c.length;n++) {
                if (regularBeneficiaryTypes.includes(formData.Beneficiary__c[n].RecordType)) {
                    regularBeneficiaryArray.push(n);
                }
            }

            if (regularBeneficiaryArray.length > 0) {
                for(let beneficiaryErrorKey in regularBeneficiaryArray) {                
                    let currIndex = regularBeneficiaryArray[beneficiaryErrorKey];

                    if(errors["Beneficiary__c"][currIndex].RecordType) {
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    } else {
                        errors["Beneficiary__c"][currIndex].RecordType = {
                            __errors: [],
                            addError: function addError(message) {
                            this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    }
                }
                
                for(let beneficiaryErrorKey in successorAnnuitantArray) {                
                    let currIndex = successorAnnuitantArray[beneficiaryErrorKey];

                    if(errors["Beneficiary__c"][currIndex].RecordType) {
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    } else {
                        errors["Beneficiary__c"][currIndex].RecordType = {
                            __errors: [],
                            addError: function addError(message) {
                            this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Hey stop adding mutually exclusive beneficiary type! XD");
                    }
                }
            }
            
            //dup successor annuitant
            if (successorAnnuitantArray.length > 1) {
                for(let beneficiaryErrorKey in successorAnnuitantArray) {
                    let currIndex = successorAnnuitantArray[beneficiaryErrorKey];
    
                    if(errors["Beneficiary__c"][currIndex].RecordType) {
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Please don't try to trick the form! You won't go forward! XD");
                    } else {
                        errors["Beneficiary__c"][currIndex].RecordType = {
                            __errors: [],
                            addError: function addError(message) {
                              this.__errors.push(message);
                            }
                        };
                        errors["Beneficiary__c"][currIndex].RecordType.addError("Please don't try to trick the form! You won't go forward! XD");
                    }
                }
            }
        }
    }
    
    if (Date.parse(formData["Contact-Birthdate"]) > (new Date()).getTime()) {
        errors["Contact-Birthdate"].addError("Date should not be after maximal date!");
    }
    
    if (formData["Spouse-Birthdate"] !== undefined && formData["Spouse-Birthdate"] !== null && (Date.parse(formData["Spouse-Birthdate"]) > (new Date()).getTime())) {
        errors["Spouse-Birthdate"].addError("Date should not be after maximal date!");
    }
        
    return errors;
}


const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
  });
  
function LinearDeterminate(props) {
    const classes = useStyles();
    const [completed, setCompleted] = React.useState(0);
    const {submitting, routeParams, message} = props;
    React.useEffect(() => {
      function progress() {
        setCompleted(oldCompleted => {
            const diff = Math.random() * 0.8;
            return Math.min(oldCompleted + diff, 100);
        });
      }
  
      const timer = setInterval(progress, 200);
      return () => {
        clearInterval(timer);
      };
    }, []);
  
    const divStyle1 = {
        fontFamily: '"Lato","Helvetica Neue",Helvetica,Roboto,Arial,sans-serif'
    };
    
    const divStyle2 = {
        fontSize: '18px'
    };
    
    return (
      <div className={classes.root}>
        <iframe allow="autoplay" src="https://player.vimeo.com/video/256667303?api=1&autoplay=1&player_id=fitvid0" frameBorder="0" id="fitvid0" width="1000px" height="426px" />
        <br />
        <br />
        <div style={{divStyle1}}>
            <h3>Sit tight and watch how our investment approach works!</h3>
            <br />
            <div style={{divStyle2}}>
                {
                    routeParams["0"] === 'kyc' ?
                        (submitting === 'submitted' ? message === 'success' ?
                            <p>Data has been saved. Please close current window and continue your work on
                                Salesforce.</p> : <p style={{color: 'red'}}>{message}</p>
                            : <p>Saving data to Salesforce...</p>)
                        : (submitting === 'submitted' ? <p>Here we go!</p> :
                        completed / 100 < 0.3 ? <p>We are working on your information!</p> :
                            completed / 100 < 0.7 ? <p>Most information are processed!</p> :
                                <p>Almost there!</p>)
                }
            </div>
        </div>
        <br />
        <LinearProgress variant="determinate" value={submitting === 'submitted' ? 100 : completed} />
        <br />
        </div>
    );
  }

const formatFinAcctString = (finAcctData) => {
    return finAcctData.Name + ": " + finAcctData.PortfolioCode;
}

const spouseInformation = {};
let  spousePreviouslyHidden = false;
const poaInformation = {};
let poaPreviouslyHidden = false;

const transformFinancialAccounts = (finAccts) => {
    const formattedLeveragedAccts = [];
    const formattedCollateralAccts = [];

    finAccts && finAccts.forEach(finAcct => {
        if (finAcct.LeveragedAccount) {
            formattedLeveragedAccts.push(formatFinAcctString(finAcct));
        }

        if (finAcct.CollateralAccount) {
            formattedCollateralAccts.push(formatFinAcctString(finAcct));
        }
    });

    return { formattedLeveragedAccts, formattedCollateralAccts };
};

class FormBuilder extends React.Component {
    constructor(props) {
        super(props);
        let self = this;
        this._form = {};
        this._portfolioCodes = [];

        this.setFormRef = element => {
            self._form = element;
        }

        this.handleNext = this.handleNext.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        let { match: { params }, getForms } = this.props;
        getForms(params);
    }

    handleSubmit(form) {
        let { forms, setActiveForm, submitForms, setFormData, match: { params } } = this.props;
        let activeIndex = 0;

        forms.forEach((currentForm, index) => {
            if (currentForm.active) {
                activeIndex = index;
            }
        })

        setFormData(forms[activeIndex].id, form.formData);
        setActiveForm(activeIndex + 1);
        if (activeIndex + 1 == forms.length) {
            submitForms(forms, params.transactionId, poaInformation);
        }
        window.scrollTo(0, 0);
    }

    handleNext() {
        this._form.submit();
    }

    handlePrevious() {
        let { forms } = this.props;
        let activeIndex = 0;

        forms.forEach((form, index) => {
            if (form.active) {
                activeIndex = index;
            }
        })
        
        this.props.setActiveForm(activeIndex - 1);

        window.scrollTo(0, 0);
    }

    handleFinish() {
        this._form.submit();
    }
    
    overwriteFinAcctsDefinition(form, combinedPortfolioCodes) {
        form.schema.definitions.financialAccounts = {
            type: "array",
            items: {
                "type": "string",
                "enum": combinedPortfolioCodes
            }
        };
    }
    
    setLegalFormAsyncTypeaheadUrls(form, combinedPortfolioCodes) {
        const currentUrl = form.uiSchema["Account-LeveragedDisclosureAccounts"].asyncTypeahead.url;

        if(currentUrl[currentUrl.length-1] === "/") {//this means the url hasn't been edited yet
            const newUrl = form.uiSchema["Account-LeveragedDisclosureAccounts"].asyncTypeahead.url + (encodeURIComponent(combinedPortfolioCodes.toString()));

            form.uiSchema["Account-LeveragedDisclosureAccounts"].asyncTypeahead.url = newUrl;
            form.uiSchema["Account-CollateralAccounts"].asyncTypeahead.url = newUrl;
        }
    }
    
    setLeveragedAndCollateralFields(form, financialAccounts, jointFinancialAccounts) {
        if(form.data["Account-LeveragedDisclosureAccounts"] === undefined || form.data["Account-CollateralAccounts"] === undefined) {
            const transformedAccounts = transformFinancialAccounts(financialAccounts.concat(jointFinancialAccounts));

            if(form.data["Account-LeveragedDisclosureAccounts"] === undefined) {
                form.data["Account-LeveragedDisclosureAccounts"] = transformedAccounts.formattedLeveragedAccts;

                if (!isEmpty(transformedAccounts.formattedLeveragedAccts)) {
                    form.data["Account-Are_you_using_borrowed_money_to_invest__c"] = "Yes";
                }
            }

            if(form.data["Account-CollateralAccounts"] === undefined) {
                form.data["Account-CollateralAccounts"] = transformedAccounts.formattedCollateralAccts;

                if (!isEmpty(transformedAccounts.formattedCollateralAccts)) {
                    form.data["Account-Have_you_pledged_these_assets__c"] = "Yes";
                }
            }
        }
    }
    
    setLegalFormValues(form, portfolioCodes, jointPortfolioCodes, financialAccounts, jointFinancialAccounts) {
        const combinedPortfolioCodes = portfolioCodes.concat(jointPortfolioCodes);
        this.overwriteFinAcctsDefinition(form, combinedPortfolioCodes);
        
        
        if (!isEmpty(financialAccounts)) {
           this.setLegalFormAsyncTypeaheadUrls(form, combinedPortfolioCodes);

           this.setLeveragedAndCollateralFields(form, financialAccounts, jointFinancialAccounts);
        }
    }
        
    render() {
        let {forms, getForms, financialAccounts, jointFinancialAccounts, portfolioCodes, jointPortfolioCodes, submitting, message, match: {params}, ...rest} = this.props;
        let self = this;

        if (forms.length && submitting === "initiated") {
            let activeStep = 0;
            let steps = forms.map((form, index) => {
                let extraActions = {
                    setSpouseReadonly: function(params, schema, uiSchema) {
                        Object.keys(schema.properties).forEach((field) => {
                            if (field.includes("Spouse-FirstName") || field.includes("Spouse-LastName")) {
                                uiSchema[field]["ui:readonly"] = true;
                            }
                        });
                    },
                    setPoaReadonly: function(params, schema, uiSchema) {
                        Object.keys(schema.properties).forEach((field) => {
                            if (field.includes("PoaContact-FirstName") || field.includes("PoaContact-LastName")) {
                                uiSchema[field]["ui:readonly"] = true;
                            }
                        });
                    },
                    updateSum: function(params, schema, uiSchema, formData) {
                        formData.totalFinancialAssets = ((formData["RegisteredMawerAsset-FinServ__Amount__c"] === undefined) ? 0 : formData["RegisteredMawerAsset-FinServ__Amount__c"])
                            + ((formData["RegisteredNonMawerAsset-FinServ__Amount__c"] === undefined) ? 0 : formData["RegisteredNonMawerAsset-FinServ__Amount__c"])
                            + ((formData["NonRegisteredMawerAsset-FinServ__Amount__c"] === undefined) ? 0 : formData["NonRegisteredMawerAsset-FinServ__Amount__c"])
                            + ((formData["NonRegisteredNonMawerAsset-FinServ__Amount__c"] === undefined) ? 0 : formData["NonRegisteredNonMawerAsset-FinServ__Amount__c"]);
                        
                        formData.totalNetWorth = ((formData["totalFinancialAssets"] === undefined) ? 0 : formData["totalFinancialAssets"])
                            + ((formData["FixedAssets-FinServ__Amount__c"] === undefined) ? 0 : formData["FixedAssets-FinServ__Amount__c"])
                            - ((formData["Liabilities-FinServ__Amount__c"] === undefined) ? 0 : formData["Liabilities-FinServ__Amount__c"]);
                        
                        formData.totalFinancialAssets = formData.totalFinancialAssets.toString();
                        formData.totalNetWorth = formData.totalNetWorth.toString();
                    },
                    updateSumFinancialAssetsBreakdown: function(params, schema, uiSchema, formData) {
                        formData.financialAssetsBreakdownSum = ((formData["AssetAllocationCash-Asset_Percentage__c"] === undefined) ? 0 : formData["AssetAllocationCash-Asset_Percentage__c"])
                            + ((formData["AssetAllocationEquity-Asset_Percentage__c"] === undefined) ? 0 : formData["AssetAllocationEquity-Asset_Percentage__c"])
                            + ((formData["AssetAllocationFixedIncome-Asset_Percentage__c"] === undefined) ? 0 : formData["AssetAllocationFixedIncome-Asset_Percentage__c"]);
                    },
                    updateBeneficiaryAllocationPercentage: function(params, schema, uiSchema, formData) {
                        let regularBeneficiaryList = [];
                        if (formData.Beneficiary__c && formData.Beneficiary__c.length > 0) {
                            regularBeneficiaryList = formData.Beneficiary__c.filter(x => {
                                return regularBeneficiaryTypes.includes(x.RecordType) || successorTypes.includes(x.RecordType)
                            });
                        }
                        if (formData["FinServ__FinancialAccount__c-No_Beneficiary_Election"]) {
                            formData.TotalBeneficiaryPercentage = 0;
                        } else {
                            if (regularBeneficiaryList && regularBeneficiaryList.length > 0) {
                                formData.TotalBeneficiaryPercentage = regularBeneficiaryList.reduce((total, currBeneficiary__c) => {
                                    return total + (currBeneficiary__c.Allocation_Percentage__c || 0);
                                }, 0);
                            } else {
                                formData.TotalBeneficiaryPercentage = 0;
                            }
                        }
                    },
                    updateContingentBeneficiaryAllocationPercentage: function(params, schema, uiSchema, formData) {
                        let contingentBeneficiaryList = [];
                        if (formData.Beneficiary__c && formData.Beneficiary__c.length > 0) {
                            contingentBeneficiaryList = formData.Beneficiary__c.filter(x => x.RecordType === "Contingent Beneficiary");
                        }
                        if (formData["FinServ__FinancialAccount__c-No_Beneficiary_Election"]) {
                            formData.TotalContingentBeneficiaryPercentage = 0;
                        } else {
                            if (contingentBeneficiaryList && contingentBeneficiaryList.length > 0) {
                                formData.TotalContingentBeneficiaryPercentage = contingentBeneficiaryList.reduce((total, currBeneficiary__c) => {
                                    return total + (currBeneficiary__c.Allocation_Percentage__c || 0);
                                }, 0);
                            } else {
                                formData.TotalContingentBeneficiaryPercentage = 0;
                            }
                        }
                    },
                    updateRecordTypeEnumTfsaSuccessorHolderRule: function(params, schema, uiSchema, formData) {
                        uiSchema.Beneficiary__c.items.RecordType["ui:enumDisabled"] = ["Beneficiary", "Estate", "Charity", "Successor Holder"];
                        formData.Beneficiary__c.forEach(x => {
                            if (x.RecordType == "Successor Holder") {
                                x.Allocation_Percentage__c = 100;
                            }
                        });
                    },
                    updateRecordTypeEnumTfsaBeneficiaryRule: function(params, schema, uiSchema) {
                        uiSchema.Beneficiary__c.items.RecordType["ui:enumDisabled"] = ["Successor Holder"];
                    },
                    updateRecordTypeEnumEstateRule: function(params, schema, uiSchema) {
                        uiSchema.Beneficiary__c.items.RecordType["ui:enumDisabled"] = ["Estate"];
                    },
                    hideSpouseSection: function(params, schema, uiSchema, formData) {
                        params.field.forEach(field => {
                            if (formData[field] != null && formData[field] != undefined) {
                                spouseInformation[field] = formData[field];
                            }
                            delete uiSchema[field];
                            delete schema.properties[field];
                        });
                        spousePreviouslyHidden = true;
                    },
                    showSpouseSection: function(params, schema, uiSchema, formData) {
                        if (spousePreviouslyHidden === true) {
                            for (let [key, value] of Object.entries(spouseInformation)) {
                                formData[key] = value;
                            }
                            spousePreviouslyHidden = false;
                        }                        
                    },
                    hidePoaSection: function(params, schema, uiSchema, formData) {
                        params.field.forEach(field => {
                            if (formData[field] != null && formData[field] != undefined) {
                                poaInformation[field] = formData[field];
                            }
                            delete uiSchema[field];
                            delete schema.properties[field];
                        });
                        poaPreviouslyHidden = true;
                    },
                    showPoaSection: function(params, schema, uiSchema, formData) {
                        if (poaPreviouslyHidden === true) {
                            for (let [key, value] of Object.entries(poaInformation)) {
                                formData[key] = value;
                            }
                            poaPreviouslyHidden = false;
                        } else {
                            params.field.forEach(field => {
                                if (formData[field] != null && formData[field] != undefined && poaInformation[field] != formData[field]) {
                                    poaInformation[field] = formData[field];
                                }
                            });
                        }                      
                    },
                    replaceLabel: function(params, schema, uiSchema) {
                        params.fields.forEach(field => {
                            if (uiSchema[field.id] && uiSchema[field.id]["ui:title"]) {
                                uiSchema[field.id]["ui:title"] = field.newLabel;
                            }
                        });
                    }
                };
                
                let { schema, uiSchema, rules = [] } = form;
                var FormWithConditionals = applyRulesHoc(schema, uiSchema, rules, Engine, extraActions)(Form);
                form.active && (activeStep = index);

                if (form.schema.title.includes("Legal Information") && form.data && !isEmpty(portfolioCodes) && jointPortfolioCodes) {
                    this.setLegalFormValues(form, portfolioCodes, jointPortfolioCodes, financialAccounts, jointFinancialAccounts);
                }

                return {
                    label: form.schema.title,
                    component: (
                        <div className="fade-in" key={activeStep}>
                            <FormWithConditionals
                                {...rest}
                                liveValidate={false}
                                key={index}
                                showErrorList={false}
                                fields={{rdp: ReactDatePicker, typeahead: TypeaheadField, asyncTypeAhead: AsyncTypeaheadField, bta: BeneficiaryTypeaheadAutocomplete }}
                                uiSchema={form.uiSchema || {}}
                                schema={form.schema}
                                formData={form.data}
                                onSubmit={self.handleSubmit}
                                ObjectFieldTemplate={ObjectFieldTemplate}
                                omitExtraData={true}
                                liveOmit={true}
                                onError={() => {
                                    this.valid = false;
                                    const element = document.getElementsByClassName("error-detail")[0];
                                    if(element !== undefined) {
                                        const elementRect = element.getBoundingClientRect();
                                        const absoluteElementTop = elementRect.top + window.pageYOffset;
                                        const middle = absoluteElementTop - (window.innerHeight / 2);
                                        window.scrollTo({
                                            top: middle,
                                            left: 0,
                                            behavior: 'smooth'
                                          });
                                    }
                                }}
                                ref={self.setFormRef}
                                transformErrors={transformErrors}
                                widgets={widgets}
                                validate={validate}
                            >
                                <div style={{ display: 'none' }}>
                                    <button type="submit">Submit</button>
                                </div>
                            </FormWithConditionals>
                        </div>
                    )
                }
            });

            return <div className='step-progress' style={{ marginBottom: '4rem' }}>
                <FormStepper
                    steps={steps}
                    activeStep={activeStep}
                    onNavigateNext={this.handleNext}
                    onNavigateBack={this.handlePrevious}
                    onFinish={this.handleFinish}
                />
            </div>
        } else {
            return <div className="text-center">
                {
                    (submitting == "submitting" || submitting == "submitted") ?
                        <LinearDeterminate submitting={submitting} routeParams={params} message={message}/>
                        :
                        <div className="spinner-border text-primary" role="status" style={{ margin: "4rem" }}>
                            <span className="sr-only">Loading...</span>
                        </div>
                }
            </div>
        }
    }
}

export default withRouter(connect(
    ({transaction}) => ({forms: transaction.forms, submitting: transaction.submitting, message: transaction.message, financialAccounts: transaction.financialAccounts, jointFinancialAccounts: transaction.jointFinancialAccounts, portfolioCodes: transaction.portfolioCodes, jointPortfolioCodes: transaction.jointPortfolioCodes}),
    dispatch => bindActionCreators(actionCreators, dispatch)
)(FormBuilder))
